export default "__VITE_ASSET__XiQHm3cT__"